import { gql } from '__generated__';

export default gql(`
  mutation DeactivatePurchase($id: ID!) {
    deactivatePurchase(id: $id) {
      id
      active
      ticket {
        id
      }
    }
  }
`);
